import { StylesConfig, GroupTypeBase } from 'react-select';
import { ALL_TEXT_STYLES } from 'src/web/components/Text/styles';
import {
  OL_COLOUR_HIGHLIGHT,
  OL_COLOUR_BLACK_55,
  OL_COLOUR_BLACK_90,
} from '../../../Style/colours';
import {
  FOCUS_OUTLINE_OFFSET,
  FOCUS_OUTLINE,
  FOCUS_BOX_SHADOW,
} from '../../../Style/mixins';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectStyles: StylesConfig<any, any, GroupTypeBase<any>> = {
  option: (base, state) => ({
    ...base,
    padding: 0,
    background: state.isFocused ? OL_COLOUR_HIGHLIGHT : 'transparent',
    outline: state.isFocused ? `2px dotted ${OL_COLOUR_BLACK_55}` : 'none',
    outlineOffset: '-2px',

    '&:hover': {
      cursor: 'pointer',
      background: OL_COLOUR_HIGHLIGHT,
      outline: 'none',
    },

    '&:not(:hover)': {
      background: 'transparent',
    },

    ...(state.isDisabled ? { cursor: 'not-allowed !important' } : {}),
  }),
  menu: (base) => ({
    ...base,
    marginTop: 0,
    borderRadius: '2px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    fontSize: 14,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  control: (base, state) => ({
    ...base,
    border: `1px solid ${OL_COLOUR_BLACK_55}`,
    borderRadius: '2px',
    outlineOffset: state.menuIsOpen ? FOCUS_OUTLINE_OFFSET : 'none',
    outline: state.menuIsOpen ? FOCUS_OUTLINE : 'none',
    boxShadow: state.menuIsOpen ? FOCUS_BOX_SHADOW : 'none',
    '&:hover': {
      border: `1px solid ${OL_COLOUR_BLACK_55}`,
    },
    ...ALL_TEXT_STYLES.formBodyText,
    margin: 0,
  }),
  input: (base) => ({
    ...base,
    minHeight: '20px',
    '> div': {
      display: 'flex !important',
      alignItems: 'center',
      justifyContent: 'center',
    },
    input: {
      ...ALL_TEXT_STYLES.formBodyText,
      boxShadow: 'none',
      margin: 0,
    },
  }),
  groupHeading: (base) => ({
    ...base,
    ...ALL_TEXT_STYLES.headingSm,
    fontSize: '14px',
    margin: 0,
    color: OL_COLOUR_BLACK_90,
    padding: '16px 16px 8px',
    lineHeight: '20px',
    textTransform: 'none',
  }),
  group: (base) => ({
    ...base,
    padding: 0,
  }),
};
